import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Entity } from '@app/enums';
import { IListService } from '@app/services';

@Injectable()
export class ChangeHistoryService implements IListService {
	endpointBase = '/api/change-history/{entity}/{id}';
	entity: Entity | string;
	id: number;

	constructor(private readonly http: HttpClient) {}

	getList(): Observable<any> {
		const endpoint = this.createUrl();
		return this.http.get<any>(endpoint);
	}

	deleteEntity(): Observable<any> {
		throw new Error('Method not implemented.');
	}

	private createUrl(): string {
		let endpoint = this.endpointBase;
		endpoint = endpoint.replace('{entity}', this.entity);
		endpoint = endpoint.replace('{id}', String(this.id));
		return endpoint;
	}
}
